// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1N4TcPxAsISTJhrIvYuFY2 {\n  align-items: center;\n  direction: ltr;\n  display: inline-block;\n  font-family: 'Material Icons';\n  font-feature-settings: 'liga';\n  font-size: 1.3rem;\n  font-style: normal;\n  font-weight: normal;\n  letter-spacing: normal;\n  line-height: 1;\n  text-transform: none;\n  vertical-align: middle;\n  white-space: nowrap;\n  word-wrap: normal;\n}\n._1N4TcPxAsISTJhrIvYuFY2._3mHxEIMPD9eML2tt-hReN5 {\n  font-size: 1rem;\n}\n._1N4TcPxAsISTJhrIvYuFY2._3Qxpm4Uo95v-JaYtRwXgP4 {\n  font-size: 2rem;\n}\n._1N4TcPxAsISTJhrIvYuFY2._27c5_INWvbfGxAfvwz7sUB {\n  position: relative;\n  top: -1px;\n}\n._1N4TcPxAsISTJhrIvYuFY2._3QG9j0mkDVzTkJ3YKStOYo {\n  position: relative;\n  top: 1px;\n}\n", ""]);
// Exports
exports.locals = {
	"icon": "_1N4TcPxAsISTJhrIvYuFY2",
	"small": "_3mHxEIMPD9eML2tt-hReN5",
	"large": "_3Qxpm4Uo95v-JaYtRwXgP4",
	"nudgeUp": "_27c5_INWvbfGxAfvwz7sUB",
	"nudgeDown": "_3QG9j0mkDVzTkJ3YKStOYo"
};
module.exports = exports;
